/*import 'magnific-popup';*/

export default function modalInfosFunding() {

    $(document).ready(function () {
        initModalFunding();
    });

    var initModalFunding = function() {

        /*$('.animated-popup').magnificPopup({
            removalDelay: 500,
            callbacks: {
                beforeOpen: function () {
                    this.st.mainClass = this.st.el.attr('data-effect');
                }
            },
            midClick: true
        });*/

        $('.btn-infos-funding, .btn-info-funding--inline').on('click', function (e) {
            let vehicleId = $(this).data('vehicle-id');

            let url = Routing.generate('api_funding', {
                id: vehicleId
            });

            $.ajax({
                url: url
            }).done(function (html) {
                $('#modalInfosFunding' + vehicleId + ' .modal-body').html(html);
            })
            ;

            e.preventDefault();
        });
    };

    global.initModalFunding = initModalFunding;
};


// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/modules/modal-infos-funding.js